export default __webpack_public_path__ + "static/media/headshot.389a3419.jpg";